import { TExperimentsState } from '../../types/experiment';
import { IApplicationState } from '../../types/redux';

export const selectExperiments = (state: IApplicationState): TExperimentsState => state.experiments;
